import styled from 'styled-components';

const RecommendedHomesStyles = styled.section`
  position: relative;
  padding-top: 30px;

  .grid-container {
    position: relative;
    max-width: 1158px;
    padding: 0px 40px;
    margin: 0 auto;
    height: 100%;
    @media screen and (max-width: 1099px) {
      padding: 0px;
      .swiper-wrapper {
        .swiper-slide:first-child {
          padding-left: 10px;
        }
      }
    }
    .DXItemsGrid-header {
      padding-left: 10px;
      @media screen and (max-width: 1099px) {
        padding-left: 20px;
      }
    }
  }

  /* .grid-container {
    max-width: 1158px;
    @media screen and (max-width: 1099px) {
      padding: 0px;
      .swiper-wrapper {
        .swiper-slide:first-child {
          padding-left: 10px;
        }
      }
    }
    .DXItemsGrid-header {
      padding-left: 10px;
      @media screen and (max-width: 1099px) {
        padding-left: 20px;
      }
    }
  } */
  .slider {
    .slide {
      background-color: white !important;
    }
  }
  .DXItemsGrid {
    position: relative;
    margin-bottom: 60px;
    .DXItemsGrid-heading {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: -0.35px;
      color: #25292d;
      margin-bottom: 5px;
    }
    .DXItemsGrid-subheading {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #4e5255;
      margin-bottom: 12px;
    }
  }
  .DXItemsGrid-grid {
    gap: 0px;
    margin: auto -10px;
    .DXTooltip-content {
      left: -90px;
    }
  }
`;

export default RecommendedHomesStyles;
